<!-- error message -->
<div *ngIf="isErrorMessage" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.InternalServerError' | translate}}</p>

    </div>
</div>



<div *ngIf="!isErrorMessage">
    <h2 class="sectionTitle">{{ 'SHARED.REPORTS.SHIPYARD_REPORT' | translate }}</h2>
    <div class="services-filter">
        <div class="form-container">
            <h4 class="section-title">{{ 'SHARED.Search' | translate}}</h4>
            <div class="form-group">
                <label for="txtCreationDateFrom">{{ 'SHARED.DateFrom' | translate}}</label>
                <input class="form-control" id="txtCreationDateFrom" name="txtCreationDateFrom" #input="bsDatepicker"
                    [(ngModel)]="creationDateFrom" bsDatepicker [minDate]='null'
                    [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
            </div>
            <div class="form-group">
                <label for="txtCreationDateTo">{{ 'SHARED.DateTo' | translate}}</label>
                <input class="form-control" id="txtCreationDateTo" name="txtCreationDateTo" #input="bsDatepicker"
                    [(ngModel)]="creationDateTo" bsDatepicker [minDate]='null'
                    [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
                <div *ngIf="ValidateDateComparsion && creationDateTo != null" class="red">
                    <div *ngIf="ValidateDateComparsion">
                        {{ 'FRONT_USER.WORK_COMPLETION_FORM.END_DATE_GREATER_ERROR' | translate }}
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="dllServiceName">{{ 'SHARED.MYREQUESTS.ServiceName' | translate}}</label>
                <select class="form-control" id="dllServiceName" name="dllServiceName" [(ngModel)]="serviceId" (change)="changeService(serviceId, false)">
                    <option value="">--- {{'SHARED.AllServices' | translate}} ---</option>
                    <option *ngFor="let service of myRequestsLookups?.Services" value="{{service.Id}}">
                        {{lang  == "Ar" ? service.NameAR : service.NameEN}}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label for="dllStatus">{{ 'SHARED.MYREQUESTS.Status' | translate}}</label>
                <select class="form-control" id="dllStatus" name="dllStatus" [(ngModel)]="serviceStatus">
                    <option value="">--- {{'SHARED.AllStatuses' | translate}} ---</option>
                    <option *ngFor="let status of myRequestsLookups?.Statuses" value="{{status.Id}}">
                        {{lang  == "Ar" ? status.StatusAR : status.StatusEN}}
                    </option>
                </select>
            </div>
            <div class="form-group">
              <label for="txtRequestNumber">{{ 'SHARED.REPORTS.EBOOKING_OBJECT.RequestNumber' | translate}}</label>
              <input type="text" class="form-control" [(ngModel)]="requestNumber" autocomplete="off">
          </div>
        </div>
        <div class="btns-holder text-center">
            <input type="button" class="btn btn-primary SCAcustomBtn" (click)="loadShipyardReport()"
                value="{{ 'SHARED.Search' | translate}}" />
            <input type="button" class="btn btn-primary SCAcustomBtn" (click)="resetMyShipyardReport()"
                value="{{ 'SHARED.ResetSearch' | translate}}" />
            <input type="button" *ngIf="!hideExportButton" class="SCAcustomBtn" (click)="ExportExcel()"
                value="{{ 'SHARED.REPORTS.EXPORT_EXCEL' | translate}}" />
        </div>
    </div>
    <app-grid-view #MyShipyardReport></app-grid-view>
</div>
